export default "__VITE_ASSET__C5XpYYZ2__"